import { AuthorizationUrl, TokenDetails, User } from "@/types";
import { proxyAxios } from "./RequestsService";

const AuthService = {
  getAuthorizationUrl: () =>
    proxyAxios.get<AuthorizationUrl>("/auth/authorization-url"),
  generateToken: (payload: { code: string; state: string }) =>
    proxyAxios.post<TokenDetails>("/auth/token", payload),
  verifyToken: () => proxyAxios.get<User>("/auth/verify"),
};

export default AuthService;
